import { useQuery } from '@tanstack/react-query';
import { useEffect, useState } from 'react';
import { useLocation } from 'react-use';

import { URL_PARAM_COLLECTION } from '$const';
import useAssets from '~hooks/useAssets';
import { queries } from '~modules/media-library/controller/api/Queries';
import { type AssetId } from '~modules/media-library/model/Asset';
import { type Collection } from '~modules/media-library/model/Collection';
import { CollectionDetail } from '~modules/media-library/view/CollectionDetail/CollectionDetail';

type CollectionDetailControllerProps = {
  assetId: AssetId;
};

export function CollectionDetailController({ assetId }: CollectionDetailControllerProps) {
  const location = useLocation();
  const { getAssetById } = useAssets();
  const asset = getAssetById(assetId);
  const [collection, setCollection] = useState<Collection>(() => ({
    id: assetId,
    title: asset?.attributes.title,
    description: asset?.attributes.description,
    responsiblePerson: '',
    link: `${location.origin}${location.pathname}?${URL_PARAM_COLLECTION}=${assetId}`,
  }));

  // load details for collection
  const { data: collectionData } = useQuery({
    ...queries.mediaLibrary.collectionDetails(assetId),
    enabled: Boolean(assetId),
    staleTime: 5 * 60 * 1000,
  });
  useEffect(() => {
    if (collectionData === undefined) return;
    setCollection(collection => ({ ...collection, ...collectionData }));
  }, [collectionData]);

  return <CollectionDetail collection={collection} />;
}
